import { useMemo } from "react";
import { getDistanceMiles } from "../utils/ai";

const FALLBACK_IMG = "/image192.png";

export default function FoodList({ user, location, homeLocation, onClaim, foods: rawFoods = [] }) {
  const foods = useMemo(() => {
    const fromLocation = homeLocation || location;
    let list = rawFoods.filter(item => !item.claimed);
    list = list.map(item => {
      const distance =
        fromLocation && item.lat && item.lng
          ? getDistanceMiles(fromLocation.lat, fromLocation.lng, item.lat, item.lng)
          : null;
      return {
        ...item,
        distance,
        isMine: item.userId === user?.uid
      };
    });
    list.sort((a, b) => (a.distance ?? 999) - (b.distance ?? 999));
    return list;
  }, [rawFoods, location, homeLocation, user?.uid]);

  return (
    <div className="space-y-3">
      {!location && !homeLocation && (
        <p className="text-xs text-yellow-600 bg-yellow-50 px-3 py-2 rounded-lg">Set home in Settings or enable location to see distances</p>
      )}
      {foods.length === 0 && (
        <p className="text-sm text-gray-400 text-center py-8">No food posted yet. Be the first donor!</p>
      )}
      {foods.map(item => (
        <div key={item.id} className="p-3 bg-gray-50/60 border border-gray-200/60 rounded-xl hover:bg-white/80 transition">
          <div className="flex gap-3">
            {/* Image thumbnail */}
            <img
              src={item.imageUrl || FALLBACK_IMG}
              alt={item.name}
              className="w-14 h-14 rounded-lg object-cover flex-shrink-0 border border-gray-200/60"
            />
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between mb-1">
                <h3 className="text-sm font-bold text-gray-800 truncate">{item.name}</h3>
                <div className="flex gap-1 flex-shrink-0">
                  {item.isMine && <span className="text-[10px] bg-green-100 text-green-600 px-1.5 py-0.5 rounded-full">Yours</span>}
                  {item.hoursLeft < 3 && <span className="text-[10px] bg-red-100 text-red-600 px-1.5 py-0.5 rounded-full">Urgent</span>}
                </div>
              </div>
              <div className="flex items-center gap-3 text-xs text-gray-500">
                <span>Qty: {item.quantity}</span>
                <span>{item.hoursLeft}h left</span>
                <span>{item.distance !== null ? `${item.distance.toFixed(1)} mi` : "-- mi"}</span>
                {item.kudos && item.kudos.length > 0 && (
                  <span className="inline-flex items-center gap-0.5 bg-amber-50 text-amber-600 px-1.5 py-0.5 rounded-full text-[10px] font-semibold">
                    {item.kudos.slice(-3).map(k => k.emoji).join("")} {item.kudos.length}
                  </span>
                )}
              </div>
              {item.address && <p className="text-xs text-gray-400 mt-1 truncate">{item.address}</p>}
            </div>
          </div>
          {/* Unclaimed — show claim button */}
          {!item.claimed && !item.isMine && onClaim && (
            <button onClick={() => onClaim(item)} className="btn-pop mt-2 w-full bg-blue-500 text-white py-1.5 rounded-lg text-xs font-semibold hover:bg-blue-600">
              Claim
            </button>
          )}
        </div>
      ))}
    </div>
  );
}
